// ======================================================================
// File Name       : CourseSearchForm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Field, reduxForm, submit } from 'redux-form';
import { Form, FormControl, Col, InputGroup } from 'react-bootstrap';
import Datetime from 'react-datetime';
import RenderField from '../../utils/ReduxFormUtils';
import { VALIDATE_TYPE } from '../../constants/index';

class CourseSearchForm extends React.Component {
  render() {
    const props = this.props;
    const { error, handleSubmit, formSubmit } = props;
    return (
      <Col sm={12} className="padding-left-right-clear">
        <h3>検索する項目を指定してください</h3>
        <Form onSubmit={handleSubmit(formSubmit)} className='form-horizontal'>
          <Col sm={12} className="padding-top-10">
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                名称
              </Col>
              <Col sm={7}>
                <Field type="text" name="name" component="input" className="form-control" />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                公開ステータス
              </Col>
              <Col sm={7}>
                <Field
                  name="publicStatus"
                  component="select"
                  className="form-select"
                  type="number"
                  parse={value => (value ? parseInt(value, 10) : '')}
                >
                  <option />
                  <option value={0}>非公開</option>
                  <option value={1}>公開</option>
                </Field>
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                コンテンツ種別
              </Col>
              <Col sm={7}>
                <Field
                  component="select"
                  name="contentType"
                  className="form-select"
                  type="number"
                  parse={value => (value ? parseInt(value, 10) : '')}
                >
                  <option />
                  <option value={0}>ビデオ</option>
                  <option value={1}>ドリル</option>
                  <option value={3}>ドキュメント</option>
                  <option value={5}>リンク</option>
                </Field>
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col sm={3} as={Form.Label}>
                公開期間
              </Col>
              <Col sm={3}>
                <RenderField
                  name="publicPeriodFrom"
                  type="datetime"
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
              <Col sm={1} className="text-center" as={Form.Label}>
                ～
              </Col>
              <Col sm={3}>
                <RenderField
                  name="publicPeriodTo"
                  type="datetime"
                  validates={[VALIDATE_TYPE.DATE_TIME]}
                  normalizeDateTime
                />
              </Col>
            </Form.Group>
            <Col sm={12}>
              <RenderField
                name="dateTimeMinMax"
                type="dateTimeMinMax"
                validates={[VALIDATE_TYPE.DATE_TIME_MIN_MAX]}
                keyDateFrom={'publicPeriodFrom'}
                keyDateTo={'publicPeriodTo'}
              />
            </Col>
            <Col sm={12}>
              <input type="submit" style={{ width: '0px', height: '0px', opacity: 0 }} id="submitBtn" name="submitBtn" />
            </Col>
          </Col>
        </Form>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'courseSearchForm',
  onSubmit: submit,
  touchOnChange: true,
})(CourseSearchForm);
